// src/actions/uiActions.js

import { types } from '../types/types';

// Abre una pantalla específica basado en su pageId
export const openScreen = (pageId) => {
    const actionType = types[pageId] || types.uiOpenScreen; // fallback
    if (!types[pageId]) {
        console.warn(`[openScreen] pageId "${pageId}" no existe en types.js; usando uiOpenScreen`);
    }
    return { type: actionType, payload: pageId };
};

// Cierra la pantalla actual
export const closeCurrentScreen = () => ({
    type: types.uiCloseCurrentScreen,
    payload: true
});

// Alterna el estado del sidebar (activo/inactivo)
export const sidebarToggle = (isActive) => ({
    type: types.uiSidebarActive,
    payload: isActive
});

// Activa o desactiva el estado de carga
export const loading = (isLoading) => ({
    type: types.loading,
    payload: isLoading
});

// Cierra la sesión del usuario
export const uiLogout = () => ({
    type: types.uiLogout
});

// Refresca la clave de actualización
export const refreshMyKey = (refreshKey) => ({
    type: types.refreshKey,
    payload: refreshKey
});
